export default global['LitiumConstants'];

export enum ViewMode {
  List,
  Edit,
  Detail,
}

export const PaginationOptions = {
  PageSize: 5, // Number of items per page
  DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
  EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where "1 2 3" and "97 98 99" are edge entries
};

export const ShippingIntegrationType = {
  Inline: 'Inline',
  DeliveryCheckout: 'DeliveryCheckout',
  PaymentCheckout: 'PaymentCheckout',
};

export const PaymentIntegrationType = {
  IframeCheckout: 'IframeCheckout',
  PaymentWidgets: 'PaymentWidgets',
  DirectPayment: 'DirectPayment',
};
export const StockStatusLevel = {
  Normal: 'Normal',
  Inactive: 'Inactive',
  Warning: 'Warning',
  SoldOut: 'SoldOut',
  OnDemand: 'OnDemand',
};

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_MINI_CART = 'CART_SHOW_MINI_CART';
export const CART_ADD_TO_CART_ANIMATION = 'CART_ADD_TO_CART_ANIMATION';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS =
  'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_SELECTED_BILLING_ADDRESS =
  'CHECKOUT_SET_SELECTED_BILLING_ADDRESS';
export const CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS =
  'CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS';
export const CHECKOUT_SET_PRIVATE_CUSTOMER =
  'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_USED_DISCOUNT_CODE =
  'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION =
  'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_UPDATE_CUSTOMER_INFO =
  'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS =
  'CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON =
  'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_ALTERNATE_ORDER_NUMBER =
  'CHECKOUT_SET_ALTERNATE_ORDER_NUMBER';
export const CHECKOUT_SET_EXTRA_REFERENCE = 'CHECKOUT_SET_EXTRA_REFERENCE';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CHECKOUT_VALIDATE_ADDRESS = 'CHECKOUT_VALIDATE_ADDRESS';
export const CHECKOUT_SET_VALIDATION_ERRORS =
  'CHECKOUT_SET_VALIDATION_ERRORS';
export const CHECKOUT_SET_IS_SUBMITTING = 'CHECKOUT_SET_IS_SUBMITTING';
export const CHECKOUT_STORE_SUCCESS = 'CHECKOUT_STORE_SUCCESS';
export const CHECKOUT_SET_PAYLOAD = 'CHECKOUT_SET_PAYLOAD';
export const CHECKOUT_DROPSHIP_PRIVATE = 'private';
export const CHECKOUT_DROPSHIP_COMPANY = 'customer';

export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT =
  'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';

export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE =
  'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';

export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW_FULL_FORM = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';
export const QUICK_SEARCH_ACTIVE_TAB = 'QUICK_SEARCH_ACTIVE_TAB';
export const QUICK_SEARCH_INPUT_ACTIVE = 'QUICK_SEARCH_INPUT_ACTIVE';

export const SEARCH_ACTIVE_TAB = 'SEARCH_ACTIVE_TAB';

export const ORDER_RECEIVE = 'ORDER_RECEIVE';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CHANGE_MODE = 'ORDER_CHANGE_MODE';
export const ORDER_CHANGE_CURRENTPAGE = 'ORDER_CHANGE_CURRENTPAGE';
export const ORDER_SET_ORDER = 'ORDER_SET_ORDER';
export const ORDER_SET_IS_LOADING = 'ORDER_SET_IS_LOADING';
export const ORDER_SET_ORDER_PAGE = 'ORDER_SET_ORDER_PAGE';

export const OVERLAY_ADD_OVERLAY = 'OVERLAY_ADD_OVERLAY';
export const OVERLAY_REMOVE_OVERLAY = 'OVERLAY_REMOVE_OVERLAY';
export const OVERLAY_CLOSE_OVERLAY = 'OVERLAY_CLOSE_OVERLAY';
export const OVERLAY_UPDATE_OVERLAY = 'OVERLAY_UPDATE_OVERLAY';

export const PRODUCT_FILTERING_RECEIVE = 'PRODUCT_FILTERING_RECEIVE';
export const PRODUCT_FILTERING_UPDATE_FILTERS =
  'PRODUCT_FILTERING_UPDATE_FILTERS';
export const PRODUCT_FILTERING_SET_SORTING =
  'PRODUCT_FILTERING_SET_SORTING';
export const PRODUCT_FILTERING_TOGGLE_FILTERBAR =
  'PRODUCT_FILTERING_TOGGLE_FILTERBAR';
export const PRODUCT_FILTERING_UPDATE_PENDING =
  'PRODUCT_FILTERING_UPDATE_PENDIN';
export const PRODUCT_FILTERING_SET_SHOW_ALL =
  'PRODUCT_FILTERING_SET_SHOW_ALL';
export const PRODUCT_FILTERING_SET_OPEN = 'PRODUCT_FILTERING_SET_OPEN';

export const PRODUCT_LISTING_SET_PRODUCTS = 'PRODUCT_LISTING_SET_PRODUCTS';
export const PRODUCT_LISTING_RECEIVE = 'PRODUCT_LISTING_RECEIVE';
export const PRODUCT_LISTING_SET_PROP = 'PRODUCT_LISTING_SET_PROP';
export const PRODUCT_LISTING_SET_IS_LOADING =
  'PRODUCT_LISTING_SET_IS_LOADING';
export const PRODUCT_LISTING_SET_URL_COUNT =
  'PRODUCT_LISTING_SET_URL_COUNT';
export const PRODUCT_LISTING_SET_SHOW_ROOM_IMAGE =
  'PRODUCT_LISTING_SET_SHOW_ROOM_IMAGE';

export const BUY_BUTTON_SET_ARTICLE_NUMBER =
  'BUY_BUTTON_SET_ARTICLE_NUMBER';
export const BUY_BUTTON_SET_LOADING = 'BUY_BUTTON_SET_LOADING';

export const LOGIN_SHOW_CHANGE_PASSWORD = 'LOGIN_SHOW_CHANGE_PASSWORD';
export const LOGIN_SHOW_SELECT_ORGANIZATION =
  'LOGIN_SHOW_SELECT_ORGANIZATION';
export const LOGIN_SET_IS_LOADING = 'LOGIN_SET_IS_LOADING';
export const LOGIN_SET_ORGANIZATIONS = 'LOGIN_SET_ORGANIZATIONS';
export const LOGIN_SET_USERNAME_PASSWORD = 'LOGIN_SET_USERNAME_PASSWORD';
export const LOGIN_SET_MODAL_OPEN = 'LOGIN_SET_MODAL_OPEN';
export const LOGIN_SET_LOGIN_MODE = 'LOGIN_SET_LOGIN_MODE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SET_REDIRECT_URL = 'LOGIN_SET_REDIRECT_URL';
export const LOGIN_SET_MAGIC_LINK_MODEL = 'LOGIN_SET_MAGIC_LINK_MODEL';

export const USER_INFO_UPDATE = 'USER_INFO_UPDATE';
export const USER_INFO_SET_ERRORS = 'USER_INFO_SET_ERRORS';

export const PRICE_HISTORY_SET_MODAL_OPEN = 'PRICE_HISTORY_SET_MODAL_OPEN';

export const PRODUCT_DETAIL_LIST_COL_SIZE_LIST = [
  6, 14, 14, 12, 7, 17, 7, 7, 7, 9,
];

export const QUICK_ORDER_LIST_COL_SIZE_LIST = [
  8, 19, 7, 7, 9, 12, 17, 4, 4, 12, 3, 23, 30,
];

export const HIDE_TIER_PRICES = true;

export const PRICE_TOGGLE_BEFORE_RELOAD_EVENT =
  'PRICE_TOGGLE_BEFORE_RELOAD_EVENT';
